import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import { handleMenuOC } from "../../Dashboard/actions/handleOpenCloseActions";
import { connect } from "react-redux";
import logoSidebar from "../../images/logoSidebar.png";
// import logoSidebar from "../../images/logo_est_polito_EC_noBackgroud.png";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  drawerPaper: {
    // overflow: "hidden",
    position: "fixed",
    whiteSpace: "nowrap",
    height: "100%",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: "#2DA830",
    color: "white",
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
}));

export const DrawerWrapper = ({
  open,
  handleMenuOC,
  mainList,
  secondaryList,
}) => {
  const classes = useStyles();
  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
      }}
      open={open}
    >
      {open ? (
        <div className={classes.toolbarIcon}>
          <img
            src={logoSidebar}
            alt="logo"
            style={{
              maxWidth: "60%",
              height: "auto",
              display: "block",
              marginLeft: "-2px",
              marginRight: "auto",
              width: "60%",
              marginBottom: "0px",
              marginTop: "5px",
            }}
          ></img>
          <h6
            style={{ fontSize: "14px", marginTop: "8px", paddingRight: "3px" }}
          >
            EST
          </h6>
          <h6
            style={{
              fontSize: "10px",
              marginTop: "16px",
              paddingRight: "12px",
            }}
          >
            RES
          </h6>
        </div>
      ) : (
        <h6
          style={{
            marginLeft: "15px",
            marginTop: "15px",
            marginBottom: "10px",
          }}
        >
          RES
        </h6>
        // <img
        //   src={logoSidebar}
        //   alt="logo"
        //   style={{
        //     maxWidth: "50%",
        //     height: "auto",
        //     display: "block",
        //     marginLeft: "11px",
        //     marginTop: "15px",
        //     marginRight: "auto",
        //     width: "50%",
        //     marginBottom: "0px",
        //   }}
        // ></img>
      )}

      <Divider />
      <List
        style={
          open
            ? { paddingTop: "10px" }
            : { paddingTop: "10px", marginTop: "14px" }
        }
      >
        {mainList}
      </List>

      <List
        style={{
          position: "absolute",
          bottom: "10px",
          left: "0",
          width: "100%",
        }}
      >
        {secondaryList}
      </List>
    </Drawer>
  );
};

const mapStateToProps = (state) => ({
  open: state.handleOpenClose.open,
});

export default connect(mapStateToProps, { handleMenuOC })(DrawerWrapper);
